<template>
  <div
    class="component title"
    :data-orientation="orientation"
    data-viewport
    @click="openContacts"
    @mouseenter="orientation === 'huge' && $store.commit('SET_POINTER', 'pointer')"
    @mouseleave="orientation === 'huge' && $store.commit('SET_POINTER', 'default')"
  >
    <span v-html="data.content.title" ref="title"></span>
  </div>
</template>

<script>
import WebGLTitle from '@/scripts/webgl/WebGLTitle';
import { isEdge } from '../scripts/utils';

export default {
  name: 'TitleBlock',

  props: {
    data: {
      type: Object,
      required: true,
      default: () => '',
    },
    orientation: {
      type: String,
      required: false,
      default: 'left',
    },
    hasDisclaimer: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      WebGLTitle: null,
      split: null,
    };
  },

  mounted() {
    this.$nextTick(() => {
      if (!isEdge()) this.WebGLTitle = new WebGLTitle(this, this.$refs.title);
    });
  },

  methods: {
    openContacts() {
      if (this.orientation === 'huge') {
        this.$store.commit('SET_CONTACT', true);
      }
    },
  },

  beforeDestroy() {
    this.WebGLTitle.destroy();
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: 'VHS';
  padding: $vertical-padding 0;
  font-size: rem(120px);
  font-size: calc(120px * var(--rw));
  line-height: rem(120px);
  line-height: calc(120px * var(--rw));

  @include mq($until: ipadL) {
    font-size: rem(100px);
    font-size: calc(100px * var(--rw));
    line-height: rem(100px);
    line-height: calc(100px * var(--rw));
  }

  @include mq($until: ipadP) {
    padding: $mobile-vertical-padding $mobile-horizontal-padding;
    font-size: rem(55px);
    font-size: calc(55px * var(--rw));
    line-height: rem(65px);
    line-height: calc(65px * var(--rw));
  }

  &[data-orientation="left"] {
    padding-left: $extra-horizontal-padding;
    width: calc((100vw / 32) * 28);

    text-align: left;

    @include mq($until: ipadL) {
      padding-left: $extra-mobile-horizontal-padding;
    }
  }

  &[data-orientation="center"] {
    font-family: 'GT America';
    font-size: rem(180px);
    font-size: calc(180px * var(--rw));
    line-height: rem(180px);
    line-height: calc(180px * var(--rw));

    text-align: center;

    @include mq($until: ipadL) {
      font-size: rem(120px);
      font-size: calc(120px * var(--rw));
      line-height: rem(120px);
      line-height: calc(120px * var(--rw));
    }

    @include mq($until: ipadP) {
      font-size: rem(80px);
      font-size: calc(80px * var(--rw));
      line-height: rem(80px);
      line-height: calc(80px * var(--rw));
    }
  }

  &[data-orientation="right"] {
    padding-left: $extra-horizontal-padding;
    width: calc((100vw / 32) * 28);

    text-align: right;

    @include mq($until: ipadL) {
      padding-left: $extra-mobile-horizontal-padding;
    }
  }

  &[data-orientation="huge"] {
    font-family: 'GT America';
    font-size: rem(360px);
    font-size: calc(360px * var(--rw));
    line-height: rem(360px);
    line-height: calc(360px * var(--rw));

    text-align: center;

    @include mq($until: ipadL) {
      padding: $extra-mobile-vertical-padding 0;
      font-size: rem(120px);
      font-size: calc(120px * var(--rw));
      line-height: rem(120px);
      line-height: calc(120px * var(--rw));
    }
  }
}
</style>
<style lang="scss">
.title {
  &__line,
  &__char {
    -webkit-clip-path: inset(0 0 0 0);
    clip-path: inset(0 0 0 0);
  }
}
</style>
